module.exports = __webpack_public_path__ + "static/media/appdevelopment.f48a34f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/appdevelopment.jpg
// module id = 152
// module chunks = 0